var _objectAssign = require('./_objectAssign');

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_assign.js
// module id = 120
// module chunks = 34471704633725 35783957827783 216468464745311